<div class="text-center root">
    <img class="ui medium circular image people-img" src={{employee.picture}}>
    <h2>{{employee.name}}</h2>
    <h3>{{employee.job}}</h3>
</div>



// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/presentation/components/garage/main/presentation/employee/employee.html